import React from "react";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";

function BreadcrumbBar({ crumbs }) {
  return (
    <div style={s.bar}>
      <Container>
      <nav aria-label="breadcrumb">
        <ol style={s.list}>
          {crumbs.map((crumb, i) => {
            const isLast = i === crumbs.length - 1;
            return (
              <React.Fragment key={i}>
                {i > 0 && <li style={s.sep} aria-hidden="true">/</li>}
                <li style={isLast ? s.active : s.item}>
                  {isLast || !crumb.to
                    ? crumb.label
                    : <Link to={crumb.to} style={s.link}>{crumb.label}</Link>}
                </li>
              </React.Fragment>
            );
          })}
        </ol>
      </nav>
      </Container>
    </div>
  );
}

const s = {
  bar:    { background: "var(--surface-2)", borderBottom: "1px solid var(--line-strong)", padding: "8px 0", marginBottom: 4 },
  list:   { display: "flex", alignItems: "center", listStyle: "none", margin: 0, padding: 0, flexWrap: "wrap", gap: 4 },
  item:   { fontSize: 13 },
  active: { fontSize: 13, color: "var(--text)", fontWeight: 600 },
  sep:    { fontSize: 13, color: "var(--text-muted)", margin: "0 2px" },
  link:   { color: "#0d6efd", textDecoration: "none" },
};

export default BreadcrumbBar;
